import { Component, Input, OnChanges } from '@angular/core';
import { hexToHSL } from 'src/app/shared/components/common/label/hex-to-hsl-converter';
import { ActivityStatus } from 'src/app/shared/models/events/activity';
import { TaskStatus } from 'src/app/shared/models/events/task';

export enum LabelType {
  Custom,
  Information,
  Warning,
  Note,
}

@Component({
  selector: 'itl-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
})
export class LabelComponent implements OnChanges {
  @Input() type: LabelType = LabelType.Custom;
  @Input() baseColor: string;
  @Input() taskStatus: TaskStatus;
  @Input() activityStatus: ActivityStatus;
  @Input() labelStyle: string;
  @Input() icon: string;
  public LabelType = LabelType;
  public TaskStatus = TaskStatus;
  public ActivityStatus = ActivityStatus;

  ngOnChanges(): void {
    if (this.type === LabelType.Information) {
      this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-info').trim();
    } else if (this.type === LabelType.Warning) {
      this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-warning').trim();
    } else if (this.type === LabelType.Note) {
      this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-note').trim();
    } else if (this.type === LabelType.Custom) {
      // Change color for Task labels
      if (this.taskStatus === TaskStatus.OFFEN) {
        this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-info').trim();
      } else if (this.taskStatus === TaskStatus.FERTIG) {
        this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-color-success').trim();
      } else if (this.taskStatus === TaskStatus.ABGELEHNT) {
        this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-warning').trim();
      }
      // Change color for Activity labels
      if (this.activityStatus === ActivityStatus.OFFEN) {
        this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-info').trim();
      } else if (this.activityStatus === ActivityStatus.FERTIG) {
        this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-color-success').trim();
      } else if (this.activityStatus === ActivityStatus.ABGELEHNT) {
        this.baseColor = getComputedStyle(document.documentElement).getPropertyValue('--alberta-label-warning').trim();
      }
      this.setLabelStyle();
    }
  }
  private setLabelStyle(): void {
    if (!this.baseColor) {
      return;
    }
    const hsl = hexToHSL(this.baseColor);
    const hslPrefix = 'hsl(' + hsl.hue + ',' + hsl.saturation + '%,';
    this.labelStyle = `
      background-color: ${hslPrefix}95%);
      border-color: ${hslPrefix}70%);
      color: ${hslPrefix}${hsl.lightness}%);
    `;
  }
}
